module.exports = __webpack_public_path__ + "static/img/rebel_pictgrid8_1060x868.39b4197.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rebel_pictgrid8_1060x868.jpg
// module id = IPUB
// module chunks = 0